import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.scss';
import App from './App.tsx';
import './locale/i18n.ts';

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('✅ Service Worker registered:', registration);
      })
      .catch((error) => {
        console.error('❌ Service Worker registration failed:', error);
      });
  });
}
// let deferredPrompt: BeforeInstallPromptEvent | null = null;

// // Type definition for BeforeInstallPromptEvent
// interface BeforeInstallPromptEvent extends Event {
//   readonly platforms?: string[];
//   readonly userChoice?: Promise<{ outcome: 'accepted' | 'dismissed', platform: string }>;
//   prompt?(): Promise<void>;
// }

// window.addEventListener('beforeinstallprompt', (e) => {
//   // Prevent auto-prompt
//   e.preventDefault();
//   deferredPrompt = e;

//   // Show your own install button
//   const installBtn = document.getElementById('installBtn');
//   if (installBtn) {
//     installBtn.style.display = 'block';

//     installBtn.addEventListener('click', async () => {
//       installBtn.style.display = 'none';
//       if (deferredPrompt && typeof deferredPrompt.prompt === 'function') {
//         await deferredPrompt.prompt();
//         if (deferredPrompt.userChoice) {
//           const choiceResult = await deferredPrompt.userChoice;
//           console.log('User response:', choiceResult.outcome);
//         }
//       }
//       deferredPrompt = null;
//     });
//   }
// });

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
